import { Tag } from "@/Components/Tag";
import { MoreVertical, User, X } from "react-feather";
import { ActionMenu } from "@/Components/ActionMenu";
import React, { useEffect, useRef, useState } from "react";
import { Inertia } from "@inertiajs/inertia";
import { InertiaLink } from "@inertiajs/inertia-react";
import { ROLE_ID } from "@/Enums/roles";
import { toast } from "react-toastify";
const Row = ({ user }) => {
  const actionMenuItems = [
    // {
    //   label: 'Remind user',
    //   callback: () => Inertia.visit(`/users/edit/${user.id}`)
    // },
    {
      label: "Edit user",
      callback: () => Inertia.visit(`/users/edit/${user.id}`),
    },
    {
      label: "Delete user",
      callback: () =>
        openModal(
          "Are you sure?",
          `You're about to remove ${user.fullname}`,
          `You're about to remove ${user.fullname} from your organization.\nDo you want to continue?`,
        ),
    },
  ];

  const actionMenuRef = useRef(null);

  let [modal, setModal] = useState({
    open: false,
    title: "",
    content: "",
    class: "",
  });
  const [toastId, setToastId] = useState(null);

  useEffect(() => {
    return () => {
      if (modal.open) {
        closeModal();
        if (toastId !== null) {
          toast.dismiss(toastId);
        }
      }
    };
  });

  const [animationClass, setAnimationClass] = useState("");

  function openModal(l, t, d, c) {
    setAnimationClass("modal-slide-in");
    setModal({ open: true, label: l, title: t, content: d, class: c });
  }

  function closeModal() {
    setAnimationClass("modal-slide-out");
    setTimeout(() => {
      setModal({ open: false, label: "", title: "", content: "", class: "" });
    }, 300);
  }

  function handleDelete() {
    setToastId(toast.loading("Please wait..."));
    Inertia.post(`/users/uninvite/${user.id}`, {
      onSuccess: () => {
        toast.update(toastId, {
          render: `User was successfully deleted`,
          type: "success",
          isLoading: false,
          autoClose: 5000,
        });
      },
      onError: (error) => {
        toast.update(toastId, {
          render: `Something went wrong when deleting user`,
          type: "error",
          isLoading: false,
          autoClose: 5000,
        });
      },
    });
  }

  return (
    <>
      <InertiaLink
        href={`/users/edit/${user.id}`}
        className="shadow-small grid-rows-[repeat(2, auto)] mb-2 grid min-h-[53px] cursor-pointer grid-cols-4 gap-2 bg-gray-light p-4 md:grid-flow-col-dense md:grid-cols-12 md:grid-rows-1 md:p-8 md:px-4 md:py-2"
      >
        <div className="col-span-3 flex items-center md:col-span-4">
          <h3
            className={`truncate leading-none ${user.firstname && user.surname ? "font-bold" : ""}`}
          >
            {user.organization_role_id === ROLE_ID.OWNER && (
              <img
                alt=""
                className="mr-2 inline"
                src="/images/diamond.svg"
                width="21px"
              />
            )}
            {user.firstname && user.surname ? user.fullname : user.email}
          </h3>
        </div>
        <div className="col-span-4 flex items-center md:col-span-7">
          <div className="row-start-2 flex flex-wrap items-center gap-2 md:row-start-1">
            {!user.firstname || !user.surname ? (
              <Tag>Pending invitation</Tag>
            ) : user.teams && user.teams.length > 0 ? (
              user.teams.map((team, i) => <Tag key={i}>{team.name}</Tag>)
            ) : null}
          </div>
        </div>
        <div className="col-span-1 col-start-4 row-start-1 flex items-center justify-end md:col-start-12">
          <div className="hover-circle relative z-10 ml-2">
            <MoreVertical
              size={24}
              className="shrink-0 cursor-pointer"
              onClick={(e) => {
                e.preventDefault();
                actionMenuRef.current.toggleMenu();
              }}
            />
            <ActionMenu ref={actionMenuRef} items={actionMenuItems} />
          </div>
        </div>
      </InertiaLink>

      {modal.open && (
        <div className="fixed left-0 top-0 z-10 flex h-full w-full flex-col justify-center bg-black bg-opacity-50 lg:pl-[240px] 4xl:pl-[300px]">
          <div
            className="absolute left-0 top-0 h-full w-full"
            onClick={closeModal}
          />
          <div className="px-4 lg:px-16 4xl:pl-32">
            <div className="mx-auto 4xl:mx-0 4xl:max-w-screen-3xl ">
              <div
                className={`relative mx-auto w-full max-w-2xl bg-white p-8 align-middle md:p-16 ${animationClass}`}
              >
                <div className="mb-2.5 flex items-center justify-between">
                  <span className="rounded-br-2xl bg-apricot px-4 py-2 text-white">
                    {modal.label}
                  </span>
                  <X
                    className="h-12 w-12 cursor-pointer p-2"
                    onClick={closeModal}
                  />
                </div>
                <h3 className="mb-3 text-xl font-semibold">{modal.title}</h3>
                <p>{modal.content}</p>

                <div className="mt-5 flex w-full justify-end border-t pt-8">
                  <a
                    className="cursor-pointer py-4 text-blue underline"
                    onClick={closeModal}
                  >
                    Never mind
                  </a>

                  <button className="btn ml-3 self-end" onClick={handleDelete}>
                    Delete {user.fullname}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Row;
